import { SetupType, setupTypeTranslationKeys } from './utils';
import { Box, Card, Chip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface MicrogridSetupBoxProps {
  imageSvg: string;
  setupType: SetupType;
}

export const MicrogridSetupBox = ({ imageSvg, setupType }: MicrogridSetupBoxProps) => {
  const { t } = useTranslation();

  // If no data provided, don't render the component
  if (!imageSvg || !setupType) {
    return null;
  }

  return (
    <Card sx={{ padding: 4, borderRadius: '8px' }}>
      <Box display="flex" flexDirection="column" gap={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{t('blueprints:details.microgridSetup.title')}</Typography>

          <Chip
            label={t(setupTypeTranslationKeys[setupType])}
            sx={{
              backgroundColor: (theme) => theme.palette.grey[800],
              color: (theme) => theme.palette.white,
              fontSize: '13px',
              fontWeight: 600,
              height: 'auto',
              padding: '6px 10px',
              borderRadius: '4px',
              '& .MuiChip-label': {
                padding: 0,
              },
            }}
          />
        </Box>

        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& svg': {
              width: '100%',
              height: 'auto',
              maxWidth: { xs: '400px', sm: '500px', md: '600px' },
            },
          }}
          dangerouslySetInnerHTML={{ __html: imageSvg }}
        />
      </Box>
    </Card>
  );
};
